enum Severity {
    error = 'error',
    warning = 'warning',
    info = 'info',
    verbose = 'log',
}

export default Severity;
